module.exports = __webpack_public_path__ + "static/media/video-20-tt.a216d68e.webm";